import { ChangeEvent, useState } from "react";
import {
  Box,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  TableRow,
  Toolbar,
  Typography,
} from "@mui/material";
import AlertSnackbars from "../molecules/common/AlertSnackBar";
import DeleteCommonModal from "../molecules/common/DeleteCommonModal";
import { useFetch } from "../../hooks/useFetch";
import AddCommonDialog from "../molecules/common/AddCommonDialog";
import { NameTableData } from "./TrusteeBank";

export default function CountryTable() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [render, setRender] = useState(false);
  const [resMsg, setResMsg] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);

  const { data: countries } = useFetch<NameTableData[]>(
    `/countries?doesIncludeUnselected=false`,
    render,
    setIsSuccess,
    setResMsg
  );

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - countries.length) : 0;

  const resourceType = "Country";

  return (
    <Box sx={{ width: "90%", mx: "auto" }}>
      <Box
        sx={{
          alignItems: "center",
          display: "flex",
          justifyContent: "space-between",
          flexWrap: "wrap",
          m: -1,
          mb: 5,
        }}
      >
        <Typography sx={{ m: 1 }} variant="h5">
          Country
        </Typography>
        <AddCommonDialog
          resourceType={resourceType}
          render={render}
          setRender={setRender}
          setIsSuccess={setIsSuccess}
          setResMsg={setResMsg}
        />
      </Box>
      <AlertSnackbars resMsg={resMsg} isSuccess={isSuccess} />
      <Grid container direction="column" alignItems="center">
        <Paper sx={{ width: 400, mb: 2 }}>
          <Toolbar
            sx={{
              pl: { sm: 2 },
              pr: { xs: 1, sm: 1 },
            }}
          >
            <Typography
              sx={{
                flex: "1 1 100%",
                textAlign: "right",
                padding: "20px",
              }}
              variant="inherit"
              component="div"
            >
              全 {countries.length} 件
            </Typography>
          </Toolbar>
          <TableContainer>
            <Table sx={{ width: 400 }} aria-labelledby="tableTitle">
              <TableBody>
                {countries
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((country, index) => {
                    const labelId = `enhanced-table-checkbox-${index}`;
                    return (
                      <TableRow tabIndex={-1} key={country.id}>
                        <TableCell
                          component="th"
                          id={labelId}
                          scope="row"
                          align="center"
                        >
                          {index + 1}
                        </TableCell>
                        <TableCell align="left">{country.name}</TableCell>
                        <TableCell>
                          <DeleteCommonModal
                            id={country.id}
                            render={render}
                            setRender={setRender}
                            setResMsg={setResMsg}
                            endpoint="/country"
                            setIsSuccess={setIsSuccess}
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                {emptyRows > 0 && (
                  <TableRow
                    style={{
                      height: 53 * emptyRows,
                    }}
                  >
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[20, 30, 50]}
            component="div"
            count={countries.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </Grid>
    </Box>
  );
}
